/**
 * Shared types + helpers for config-driven claim disclaimers. Kept in a
 * non-component module so the `<DisclaimerAck>` component file only exports a
 * component (react-refresh rule).
 */

export interface DisclaimerConfig {
  context: string
  text: string
  title?: string
  require_acknowledgement: boolean
  acknowledgement_label: string
  version: number
}

/** True when an unticked, acknowledgement-required disclaimer should block submit. */
export function disclaimerBlocks(
  disclaimer: DisclaimerConfig | null | undefined,
  acknowledged: boolean,
): boolean {
  return !!disclaimer?.require_acknowledgement && !acknowledged
}

/** The value recorded on the claim when acknowledged: ``<context>:v<version>``. */
export function disclaimerAckValue(disclaimer: DisclaimerConfig): string {
  return `${disclaimer.context}:v${disclaimer.version}`
}
